import { isAfter, isBefore } from "date-fns";

export const DEFAULT_INVALID_DATE_MESSAGE = "Please enter a valid date";
export const DEFAULT_BEFORE_MIN =
  "The date you selected is before the earliest allowed date";
export const DEFAULT_AFTER_MAX =
  "The date you selected is after the latest allowed date";

export const formatErrorMessageText = (
  actual: string,
  min?: string,
  max?: string,
) => {
  const actualDate = new Date(actual);
  const minDate = min && new Date(min);
  const maxDate = max && new Date(max);

  if (minDate && isBefore(actualDate, minDate)) {
    return DEFAULT_BEFORE_MIN;
  }

  if (maxDate && isAfter(actualDate, maxDate)) {
    return DEFAULT_AFTER_MAX;
  }

  return DEFAULT_INVALID_DATE_MESSAGE;
};
